$shm_hitalama_map_settings $mol_list
	map $shm_hitalama_map
		slideshow_enabled? => slideshow_enabled?
		camera_locked? => camera_locked?
		backup_time? => backup_time?
		slideshow_frame? => slideshow_frame?
		slideshow_frame_str => slideshow_frame_str
		viewport_frames_visible? => viewport_frames_visible?
	zoom? 1
	shift? $mol_vector_2d<number> /
		0
		0
	sub /
		<= Scale $mol_button_minor
			title <= scale_percent \100%
			click? <=> reset_scale? null
		<= Description_field $mol_form_field
			name \Описание
			Content <= Description_edit $mol_textarea
				value? <=> description? \
		<= Editor_mode_enabled $mol_check_box
			title \Режим редактора
			checked? <=> editor_mode_enabled? false
		<= Widget_list_visible $mol_check_box
			title \Cписок виджетов
			checked? <=> widget_list_visible? false
		- <= File_list_visible $mol_check_box
			title \Список файлов
			checked? <=> file_list_visible? false
		<= Widget_props_visible $mol_check_box
			title \Параметры виджета
			checked? <=> widget_props_visible? false
		<= Widget_headers_visible $mol_check_box
			title \Шапки виджетов
			checked? <=> widget_headers_visible? false
		<= Viewport_frames_visible $mol_check_box
			title \Viewport-frames
			checked? <=> viewport_frames_visible?
		<= Arrows_visible $mol_check_box
			title \Стрелки
			checked? <=> arrows_visible? true
		<= Slideshow_controls $mol_view
			sub /
				<= Slideshow_enabled $mol_check_box
					title \Режим просмотра
					checked? <=> slideshow_enabled?
				- <= Num_view $mol_text
					text <= slideshow_frame_str \1
				<= Num $mol_paginator
					value? <=> slideshow_frame?
		<= Camera_locked $mol_check_box
			title \Заблокировать камеру
			checked? <=> camera_locked?
		<= Backup_controls $mol_view
			sub /
				<= Backup_label $mol_text
					text \Автосохранение каждые, мин
				<= Backup_time $mol_string
					value? <=> backup_time?
		<= Export $mol_button_download
			uri <= exported_json \
			file_name <= exported_file_name \
			title \Экспорт карты
		<= Export_without_files $mol_button_download
			uri <= exported_without_files_json \
			file_name <= exported_without_files_file_name \
			title \Экспорт карты без файлов
		<= Restore $shm_hitalama_attach
			attach_title \Восстановить из файла
			attach_new? <=> restore_file? null
		<= Cut_map $mol_pick
			align \center
			showed? <=> cut_bubble_showed? false
			trigger_content /
				<= Cut_icon $mol_icon_trash_can
				\Удалить
			bubble_content /
				<= Cut_bubble $mol_view
					sub /
						<= Cut_text $mol_text
							text \Удалить?
						<= Cut_yes $mol_button_minor
							title \Да
							click? <=> map_cut? null
						<= Cut_no $mol_button_minor
							title \Нет
							click? <=> cut_cancel? null
